import { connect } from 'react-redux'
import ResetPassword from './components/Login/ResetPassword'

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ auth: state.auth }), mapDispatchToProps)(ResetPassword)
